module.exports = __webpack_public_path__ + "static/img/7.70e6034d.png";